import { render } from "./eup-permission.vue?vue&type=template&id=4a49abc4"
import script from "./eup-permission.vue?vue&type=script&lang=js"
export * from "./eup-permission.vue?vue&type=script&lang=js"

import exportComponent from "F:\\物流项目\\新版项目物流项目\\delivery\\Source\\Delivery.Admin.UI\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__